function nexTimeSlotName(c) {
  return String.fromCharCode(c.charCodeAt(0) + 1);
}

function prevTimeSlotName(c) {
  return String.fromCharCode(c.charCodeAt(0) - 1);
}

export function getNextName(name) {
  const lastChar = name[name.length - 1];
  const shorterByOneArray = name.slice(0, name.length - 1);

  if (lastChar === 'Z') {
    return Array(name.length + 2).join('A');
  }

  return `${shorterByOneArray}${nexTimeSlotName(lastChar)}`;
}

export function getPreviousName(name) {
  const lastChar = name[name.length - 1];
  const shorterByOneArray = name.slice(0, name.length - 1);
  if (lastChar === 'A') {
    return Array(shorterByOneArray.length + 1).join('Z');
  }

  return `${shorterByOneArray}${prevTimeSlotName(lastChar)}`;
}
